<form class="form-bubble" [formGroup]="filterForm">
  <div class="row">
    <div class="col">
      <div class="comments">
        <strong>{{localize(langSection.TrailerCard, langText.Comments)}}</strong>
        <div class="form-check">
          <input id="unreadCommentsOnly" type="checkbox" name="unreadCommentsOnly" class="form-check-input"
            value="unreadCommentsOnly" formControlName="unreadCommentsOnly">
          <label for="unreadCommentsOnly" class="form-check-label">
            {{localize(langSection.HomePage, langText.UnreadComments)}}
          </label>
        </div>
      </div>
      <div formGroupName="trailerDirection" class="trailer-direction">
        <strong>{{localize(langSection.HomePage, langText.TrailerDirection)}}</strong>
        <div class="form-check">
          <input id="fromUps" type="checkbox" class="form-check-input" value="From UPS" formControlName="From UPS">
          <label for="fromUps" class="form-check-label">
            {{localize(langSection.HomePage, langText.FromUPS)}}
          </label>
        </div>
        <div class="form-check">
          <input id="toUps" type="checkbox" class="form-check-input" value="To UPS" formControlName="To UPS">
          <label for="toUps" class="form-check-label">
            {{localize(langSection.HomePage, langText.ToUPS)}}
          </label>
        </div>
      </div>
      <div formGroupName="planNotMet">
        <strong>{{localize(langSection.HomePage, langText.PlanNotMet)}}</strong>
        <div class="form-check">
          <input id="notPlanned" type="checkbox" class="form-check-input" value="Not Planned"
            formControlName="Not Planned">
          <label for="notPlanned" class="form-check-label">
            {{localize(langSection.HomePage, langText.NotPlanned)}}
          </label>
        </div>
        <div class="form-check">
          <input id="tractorOnly" type="checkbox" class="form-check-input" value="Tractor Only"
            formControlName="Tractor Only">
          <label for="tractorOnly" class="form-check-label">
            {{localize(langSection.HomePage, langText.TractorOnly)}}
          </label>
        </div>
      </div>
    </div>

    <div class="col">
      <div formGroupName="createdAs">
        <strong>{{localize(langSection.HomePage, langText.CreatedAs)}}</strong>
        <div class="form-check">
          <input id="planned" type="checkbox" class="form-check-input" value="Planned"
            formControlName="Planned">
          <label for="planned" class="form-check-label">
            {{localize(langSection.RequestCategory, langText.Planned)}}
          </label>
        </div>
        <div class="form-check">
          <input id="adhoc" type="checkbox" class="form-check-input"  value="Ad Hoc"
            formControlName="Ad Hoc">
          <label for="adhoc" class="form-check-label">
            {{localize(langSection.RequestCategory, langText.AdHoc)}}
          </label>
        </div>
      </div>
      <div formGroupName="requestType">
        <strong>{{localize(langSection.HomePage, langText.RequestType)}}</strong>
        <div class="form-check">
          <input id="delivery" type="checkbox" name="delivery" class="form-check-input" value="Delivery"
            formControlName="Delivery">
          <label for="delivery" class="form-check-label">
            {{localize(langSection.RequestType, langText.Delivery)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Request Empty" id="empty-checkbox"
            formControlName="Request Empty">
          <label class="form-check-label" for="empty-checkbox">
            {{localize(langSection.RequestType, langText.RequestEmpty)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Live Load" id="live-load-checkbox"
            formControlName="Live Load">
          <label class="form-check-label" for="live-load-checkbox">
            {{localize(langSection.RequestType, langText.LiveLoad)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="REALIGN" id="realign-checkbox"
            formControlName="REALIGN">
          <label class="form-check-label" for="realign-checkbox">
            {{localize(langSection.RequestType, langText.REALIGN)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Retrieve Empty" id="retrieve-empty-checkbox"
            formControlName="Retrieve Empty">
          <label class="form-check-label" for="retrieve-empty-checkbox">
            {{localize(langSection.RequestType, langText.RetrieveEmpty)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Retrieve Load" id="retrieve-load-checkbox"
            formControlName="Retrieve Load">
          <label class="form-check-label" for="retrieve-load-checkbox">
            {{localize(langSection.RequestType, langText.RetrieveLoad)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Switch" id="switch-checkbox" formControlName="Switch">
          <label class="form-check-label" for="switch-checkbox">
            {{localize(langSection.RequestType, langText.Switch)}}
          </label>
        </div>
      </div>
    </div>
    <div class="col">
      <div formGroupName="trailerType" class="trailer-type">
        <strong>{{localize(langSection.HomePage, langText.TrailerType)}}</strong>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Short" id="short-checkbox" formControlName="Short">
          <label class="form-check-label" for="short-checkbox">
            {{localize(langSection.TrailerType, langText.Short)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="Long" id="long-checkbox" formControlName="Long">
          <label class="form-check-label" for="long-checkbox">
            {{localize(langSection.TrailerType, langText.Long)}}
          </label>
        </div>
      </div>
      <div formGroupName="trailerVolume">
        <strong>{{localize(langSection.HomePage, langText.TrailerVolume)}}</strong>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="volume-checkbox" value="Volume" formControlName="Volume">
          <label class="form-check-label" for="volume-checkbox">
            {{localize(langSection.HomePage, langText.Volume)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="no-volume-checkbox" value="No Volume"
            formControlName="No Volume">
          <label class="form-check-label" for="no-volume-checkbox">
            {{localize(langSection.HomePage, langText.NoVolume)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="pallets-checkbox" value="Pallets"
            formControlName="Pallets">
          <label class="form-check-label" for="pallets-checkbox">
            {{localize(langSection.HomePage, langText.Pallets)}}
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="gaylords-checkbox" value="Gaylords"
            formControlName="Gaylords">
          <label class="form-check-label" for="gaylords-checkbox">
            {{localize(langSection.HomePage, langText.Gaylords)}}
          </label>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="form-group destination-multiselect">
        <destination-multiselect
          [fieldLabel]="'Destination'"
          [options]="destinationOptions"
          [displayName]="true"
          (onSelectedValuesChange)="onDestinationsChange($event)">
        </destination-multiselect>
      </div>
      <div class="form-group earliest-date">
        <strong>{{localize(langSection.HomePage, langText.EarliestDueDate)}}</strong>
        <datepicker class="datepicker" [(date)]="earlistDueDate" (onChange)="dateChanged($event, 'earliestDueDate')">
        </datepicker>
      </div>
      <div class="form-group">
        <strong>{{localize(langSection.HomePage, langText.LatestDueDate)}}</strong>
        <datepicker [disableBefore]="lowerLimit" class="datepicker" [(date)]="latestDueDate"
          (onChange)="dateChanged($event, 'latestDueDate')"></datepicker>
      </div>
    </div>
    <div class="col" formGroupName="destinationSort">
      <strong>{{localize(langSection.HomePage, langText.DestinationSort)}}</strong>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="S" id="sunrise-checkbox" formControlName="S">
        <label class="form-check-label" for="sunrise-checkbox">
          {{localize(langSection.Sort, langText.Sunrise)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="P" id="preload-checkbox" formControlName="P">
        <label class="form-check-label" for="preload-checkbox">
          {{localize(langSection.Sort, langText.Preload)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="M" id="morning-checkbox" formControlName="M">
        <label class="form-check-label" for="morning-checkbox">
          {{localize(langSection.Sort, langText.Morning)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="D" id="day-checkbox" formControlName="D">
        <label class="form-check-label" for="day-checkbox">
          {{localize(langSection.Sort, langText.Day)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="A" id="afternoon-checkbox" formControlName="A">
        <label class="form-check-label" for="afternoon-checkbox">
          {{localize(langSection.Sort, langText.Afternoon)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="L" id="local-checkbox" formControlName="L">
        <label class="form-check-label" for="local-checkbox">
          {{localize(langSection.Sort, langText.Local)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="T" id="twilight-checkbox" formControlName="T">
        <label class="form-check-label" for="twilight-checkbox">
          {{localize(langSection.Sort, langText.Twilight)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="N" id="night-checkbox" formControlName="N">
        <label class="form-check-label" for="night-checkbox">
          {{localize(langSection.Sort, langText.Night)}}
        </label>
      </div>
    </div>
    <div class="col" formGroupName="serviceLevel">
      <strong>{{localize(langSection.HomePage, langText.ServiceLevel)}}</strong>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="EAM" id="early-am-checkbox" formControlName="EAM">
        <label class="form-check-label" for="early-am-checkbox">
          {{localize(langSection.ServiceLevel, langText.EarlyAM)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="1DA" id="next-day-checkbox" formControlName="1DA">
        <label class="form-check-label" for="next-day-checkbox">
          {{localize(langSection.ServiceLevel, langText.NextDayAir)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="2DA" id="second-day-checkbox" formControlName="2DA">
        <label class="form-check-label" for="second-day-checkbox">
          {{localize(langSection.ServiceLevel, langText.SecondDayAir)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="3DS" id="three-day-checkbox" formControlName="3DS">
        <label class="form-check-label" for="three-day-checkbox">
          {{localize(langSection.ServiceLevel, langText.ThreeDaySelect)}}
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="GRD" id="ground-checkbox" formControlName="GRD">
        <label class="form-check-label" for="ground-checkbox">
          {{localize(langSection.ServiceLevel, langText.Ground)}}
        </label>
      </div>
    </div>
  </div>
  <div class="row mt-4 justify-content-center">
    <div class="col-auto"><button type="submit" class="btn btn-green"
        (click)="onApplyClick()">{{localize(langSection.HomePage, langText.Apply)}}</button></div>
    <div class="col-auto"><button class="btn btn-link"
        (click)="clearFilters(filterForm)">{{localize(langSection.HomePage, langText.ClearFilters)}}</button></div>
  </div>
</form>
